import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  fetchAdmins() {
    return api.get('/admins');
  },
  getActivityList({ page, total, startDate, endDate, filter }) {
    const params = {
      cursor: page,
      limit: total,
      start_date: startDate,
      end_date: endDate,
      actor_id: filter,
    };
    const url = '/activities';
    return api.get(url, { params: omitBy(params, isNil) });
  },
};
